import { useMutation } from '@tanstack/react-query';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { ApiEnvelope } from '../../../types';
import { DrChronoTask, DrChronoTaskError, DrChronoTaskUpdate } from '../types';
import useOnTaskSaved from './useOnTaskSaved';

type Variables = { taskId: number; body: DrChronoTaskUpdate };

const useUpdateDrChronoTask = (member_id: number | null | undefined, onSuccess?: () => void) => {
    const req = useRequest();

    return useMutation<DrChronoTask, DrChronoTaskError, Variables>({
        mutationFn: ({ taskId, body }) =>
            req<ApiEnvelope<DrChronoTask>>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/drchrono-tasks/${taskId}/`,
                method: 'PATCH',
                body: JSON.stringify(body)
            }).then((response) => response.data),
        onSuccess: useOnTaskSaved(member_id, 'updated', onSuccess),
        onError: (error) => error
    });
};

export default useUpdateDrChronoTask;
